// shared.module.ts
import { NgModule } from '@angular/core';
import { GenericFilterPipe } from '../pipes/generic-filter.pipe';

@NgModule({
  declarations: [GenericFilterPipe],
  exports: [GenericFilterPipe] // This is crucial! You need to export it so other modules can use it.
})
export class SharedModule {}
